import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Autoplay, Navigation, Pagination]);


document.addEventListener('DOMContentLoaded',function() {

    const big = document.getElementsByClassName('js-bigslide')[0],
          gallery = document.getElementsByClassName('js-galleryslide')[0],
          invest = document.getElementsByClassName('js-investslide'),
          offer = document.getElementsByClassName('js-offerslide');

    window.gallerySlide = function() {
	    const swiper = new Swiper(gallery, {
    	    autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: gallery.getElementsByClassName('swiper-button-next')[0],
                prevEl: gallery.getElementsByClassName('swiper-button-prev')[0]
            },
    	    slidesPerView: 2,
            breakpoints: {
                641: {
                    slidesPerView: 3,
                },
            },
            // loop: true,
	    });
    };

    window.bigSlide = function() {
	    const swiper = new Swiper(big, {
    	    autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            speed: 800,
            // loop: true,
	    });
    };

    window.investSlide = function() {

        for (let i = 0; i < invest.length; i++) {
            if (invest[i].getElementsByClassName('swiper-slide').length > 1) {
                const swiper = new Swiper(invest[i], {
                    autoplay: {
                        delay: 5000,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                });
            } else {
                invest[i].classList.add('swiper-disabled');
            }
        }
    };


    const offerSlide = function() {

	    for (let i = 0; i < offer.length; i++) {
    	    const swiper = new Swiper(offer[i], {
        	    autoplay: {
                    delay: 5000,
                },
        	    slidesPerView: 1,
                navigation: {
                    nextEl: offer[i].parentNode.getElementsByClassName('swiper-button-next')[0],
                    prevEl: offer[i].parentNode.getElementsByClassName('swiper-button-prev')[0]
                },
                breakpoints: {
                    376: {
                        slidesPerView: 2,
                        spaceBetween: 10
                    },

                    769: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                },
                loop: true,
    	    });
	    }
    };

    offer.length > 0 ? offerSlide() : false;


}, false)
